import { createDetachedElement } from '@syllepsis/adapter';
import { AllSelection, Plugin, PluginKey, TextSelection } from 'prosemirror-state';
import { CellSelection } from 'prosemirror-tables';
import { NODE_NAME } from './const';
import { TableContextMenu } from './table-context-menu';
import { closestCell, judgeSelectAllTable } from './utils';
var KEY = new PluginKey('tableHelper');
var getCellPosInTable = function (table, anchorCell, headCell) {
    var anchor = 0;
    var head = 0;
    table.content.forEach(function (tableRow, offset) {
        if (anchor && head)
            return false;
        tableRow.content.forEach(function (tableCell, cellOffset) {
            if (tableCell === anchorCell)
                anchor = offset + cellOffset;
            else if (tableCell === headCell)
                head = offset + cellOffset;
        });
    });
    return {
        anchor: anchor,
        head: head,
    };
};
var TableHelperPlugin = function (editor, menus) {
    return new Plugin({
        key: KEY,
        view: function (view) { return new TableContextMenu(editor, view, menus); },
        props: {
            handleDOMEvents: {
                cut: function (view, event) {
                    var state = view.state, dispatch = view.dispatch;
                    var tr = state.tr;
                    if (judgeSelectAllTable(editor)) {
                        var $pos = state.selection.$anchor;
                        var node = $pos.node(1);
                        if (node.type.spec.tableRole === 'table') {
                            var from = $pos.before(1);
                            var to = $pos.after(1);
                            dispatch(tr.setSelection(TextSelection.create(tr.doc, from, to)));
                        }
                    }
                    return false;
                },
            },
            transformPastedHTML: function (html) {
                var metas = /(\s*<meta [^>]*>)*/.exec(html);
                var result = html;
                if (metas)
                    result = html.slice(metas[0].length);
                var $div = createDetachedElement('div');
                $div.innerHTML = result;
                if ($div.children.length === 1) {
                    var $context = $div.querySelector('[data-pm-slice]');
                    var sliceData = $context && /^(\d+) (\d+) (.*)/.exec($context.getAttribute('data-pm-slice') || '');
                    try {
                        // when copying a single text in the table, remove `data-pm-slice`.(it will cause contain table_cell)
                        if ($context &&
                            sliceData &&
                            sliceData[1] === sliceData[2] &&
                            sliceData[3].indexOf('["table",null,"table_row",null,') === 0) {
                            $context.removeAttribute('data-pm-slice');
                        }
                    }
                    catch (e) {
                        return html;
                    }
                }
                return $div.innerHTML;
            },
        },
        appendTransaction: function (trs, oldState, newState) {
            if (newState.selection instanceof CellSelection || newState.selection instanceof AllSelection) {
                return;
            }
            var _a = newState.selection, $from = _a.$from, $to = _a.$to, empty = _a.empty;
            if (empty || !$from.depth || !$to.depth)
                return;
            var fromNode = $from.node(1);
            var toNode = $from.node(1);
            if (fromNode.type.name === NODE_NAME.TABLE && fromNode === toNode) {
                // convert all selected across cells in the table to CellSelection
                var fromCell = closestCell($from);
                var toCell = closestCell($to);
                if (!fromCell || !toCell || fromCell.node === toCell.node)
                    return;
                var _b = getCellPosInTable(fromNode, fromCell.node, toCell.node), anchor = _b.anchor, head = _b.head;
                var startPos = $from.before(1) + 2;
                return newState.tr.setSelection(CellSelection.create(newState.doc, startPos + anchor, startPos + head));
            }
        },
    });
};
export { TableHelperPlugin };
//# sourceMappingURL=table-helper.js.map